import React from 'react';
import DataManagementComponent from '../components/DataManagement/DataManagementComponent';

const DataManagement: React.FC = () => {
  return (
    <div style={{ padding: 24 }}>
      <h2>Data Management Center</h2>
      <DataManagementComponent />
    </div>
  );
};

export default DataManagement;
